// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/resources/:slug\",\"regex\":\"^/resources/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/about/news\"},{\"path\":\"/about/news/commonly-asked-questions\"},{\"path\":\"/activate\"},{\"path\":\"/careers\"},{\"path\":\"/contact-us\"},{\"path\":\"/credit-cards/gold-line-visa\"},{\"path\":\"/credit-cards/green-line-visa\"},{\"path\":\"/credit-cards/secured-visa\"},{\"path\":\"/credit-cards/silver-line-visa\"},{\"path\":\"/download/apps\"},{\"path\":\"/legal\"},{\"path\":\"/legal/autopay-terms\"},{\"path\":\"/legal/cardholder-agreements\"},{\"path\":\"/legal/cash-back-terms\"},{\"path\":\"/legal/consumer-privacy-notice\"},{\"path\":\"/legal/customer-identity-verification-requirements\"},{\"path\":\"/legal/digital-wallet-terms\"},{\"path\":\"/legal/electronic-communications-disclosure-and-consent\"},{\"path\":\"/legal/licenses\"},{\"path\":\"/legal/mission-lane-1-1-5-2-cash-back-program-terms-issued-by-tab-bank\"},{\"path\":\"/legal/mission-lane-1-1-5-2-cash-back-program-terms-issued-by-webbank\"},{\"path\":\"/legal/mission-lane-3-travel-dining-gas-earn-cash-back-program-terms-issued-by-tab\"},{\"path\":\"/legal/mission-lane-3-travel-dining-gas-earn-cash-back-program-terms-issued-by-webbank\"},{\"path\":\"/legal/mission-lane-up-to-3-dynamic-earn-cash-back-program-terms-issued-by-tab-bank\"},{\"path\":\"/legal/mission-lane-up-to-3-dynamic-earn-cash-back-program-terms-issued-by-webbank\"},{\"path\":\"/legal/privacy-and-security\"},{\"path\":\"/legal/privacy-policy\"},{\"path\":\"/legal/terms-of-use\"},{\"path\":\"/legal/the-mission-lane-secured-visa-r-credit-card-issued-by-transportation-alliance-bank-inc-dba-tab-bank-2024\"},{\"path\":\"/legal/the-mission-lane-visa-credit-card-issued-by-transportation-alliance-bank-inc-dba-tab-bank\"},{\"path\":\"/legal/the-mission-lane-visa-credit-card-issued-by-transportation-alliance-bank-inc-dba-tab-bank-2\"},{\"path\":\"/legal/the-mission-lane-visa-credit-card-issued-by-webbank\"},{\"path\":\"/legal/the-mission-lane-visa-credit-card-issued-by-webbank-2\"},{\"path\":\"/money\"},{\"path\":\"/resources\"}]}";globalThis["_sentryNextJsVersion"] = "16.4.3";import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: 'https://57c61c78a2bdd02f072187684e9781db@o543490.ingest.us.sentry.io/4508892885811200',

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 0.05,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Enable Sentry only if RELEASE_VERSION is set (i.e. in staging and prod)
  enabled: !!process.env.RELEASE_VERSION,

  // Getting analytics to show up under the correct environment in Sentry
  environment: process.env.VERCEL_ENV,

  release: process.env.RELEASE_VERSION,

  // Preserve the restrictive v10 data-collection defaults (v11 defaults are more permissive)
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    },
    httpBodies: [],
    urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
  },
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
